/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Videos_HintInputs */

const cs_videos_hint = /** @type {(inputs: Videos_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrajte MP4 nebo MOV (max. 10). Sreality stáhne soubor z URL a zpracuje ho u sebe.`)
};

const en_videos_hint = /** @type {(inputs: Videos_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload MP4 or MOV (max 10). Sreality fetches the file URL and transcodes on their side.`)
};

/**
* | output |
* | --- |
* | "Upload MP4 or MOV (max 10). Sreality fetches the file URL and transcodes on their side." |
*
* @param {Videos_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const videos_hint = /** @type {((inputs?: Videos_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Videos_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_videos_hint(inputs)
	return cs_videos_hint(inputs)
});